module.exports = __webpack_public_path__ + "static/img/Screenshot_2019-01-10 Y S-min.75e62f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/min/Screenshot_2019-01-10 Y S-min.jpg
// module id = SydH
// module chunks = 1